























































































































































import { Component, Vue } from 'vue-property-decorator';
import CommonInput from "@/components/common/CommonInput.vue";
import SecureInput from "@/components/common/SecureInput.vue";
import DateInput from "@/components/common/DateInput.vue";
import CommonSelect from "@/components/common/CommonSelect.vue";
import UploadFile from "@/components/common/UploadFile.vue";
import CountrySelect from "@/components/form/CountrySelect.vue";
import InputRules from "@/utils/InputRules";
import ApiErrors from "@/utils/ApiErrors";
import UploadType from "@/utils/FileUploadType";
import {FileAvatarResponse} from "@/models/File/FileAvatarResponse";
import {AuthService} from "@/services/AuthService";
import {get} from "@/context/context";
import API from "@/utils/Api";
import {UserResponse} from "@/models/User/UserResponse";
import {UserRegisterResponse} from "@/models/User/UserRegisterResponse";
import {Servers, defaultServer, urls} from "@/serverConfig";

@Component({
  components: {
    CommonInput,
    SecureInput,
    DateInput,
    CommonSelect,
    CountrySelect,
    UploadFile
  },
})
export default class SignUp extends Vue {
  private authService: AuthService = get('authService');
  private api: API = get('api');

  private color: string = "deep-purple darken-4"
  private formValid: boolean = true;
  private UploadType = UploadType;
  private formData = {
    firstName: '',
    lastName: '',
    email: '',
    birthday: '',
    gender: '',
    countryId: '',
    state: '',
    city: '',
    zipCode: '',
    password: '',
    passwordConfirm: '',
    photoUrl: ''
  };
  private formErrors = {
    firstName: '',
    lastName: '',
    email: '',
    birthday: '',
    gender: '',
    countryId: '',
    state: '',
    city: '',
    zipCode: '',
    password: '',
    passwordConfirm: '',
    photoUrl: ''
  };

  private genderItems = [
    {id: 'male', name: this.$t('signup_page.form.inputs.gender.items.male')},
    {id: 'female', name: this.$t('signup_page.form.inputs.gender.items.female')},
    {id: 'non', name: this.$t('signup_page.form.inputs.gender.items.non')}];
  private isLogging:boolean = false;

  get rules() {
    return {
      requiredRules: [
        (v: any) => InputRules.required(v) || this.$t('default.form.inputs.required_error'),
      ],
      email: [
        (v: any) => InputRules.required(v) || this.$t('login_page.form.inputs.email.required_error'),
        (v: any) => InputRules.emailTest(v) || this.$t('login_page.form.inputs.email.invalid_error'),
      ],
      password: [
        (v: any) => InputRules.required(v) || this.$t('login_page.form.inputs.password.required_error'),
        (v: any) => InputRules.min(v, 8) || this.$t('login_page.form.inputs.password.length_error'),
      ],
      passwordConfirm: [
        (v: any) => InputRules.required(v) || this.$t('login_page.form.inputs.password.required_error'),
        (v: any) => InputRules.min(v, 8) || this.$t('login_page.form.inputs.password.length_error'),
        (v: any) =>  v === this.formData.password  || this.$t('signup_page.form.inputs.password_confirm.match_error'),
      ]
    }
  }

  private clearErrors() {
    this.formErrors = {
      firstName: '',
      lastName: '',
      email: '',
      birthday: '',
      gender: '',
      countryId: '',
      state: '',
      city: '',
      zipCode: '',
      password: '',
      passwordConfirm: '',
      photoUrl: ''
    };
  }

  private async validate() {
    (this.$refs.form as any).validate();

    // if (!this.formData.photoUrl) {
    //   this.formErrors.photoUrl = this.$t('login_page.form.inputs.required_error')
    // }
  }

  private saveAvatar(file:FileAvatarResponse) {
    this.formData.photoUrl = file.path;
  }

  private async handleSubmit(){
    this.isLogging = true;
    this.clearErrors();
    await this.validate();

    if (!this.formValid) {
      this.isLogging = false;
      return;
    }

    try {
      const selectServer = defaultServer;
      this.api.changeServer(selectServer);

      const data = await this.authService.register(this.formData);
      const user = data as UserRegisterResponse;

      Promise.all( Object.keys(urls).map(async (key: string) => {
        if (key !== selectServer) {
          this.api.changeServer(key);
          let otherServer = await this.authService.register(this.formData);
          let otherInfo = otherServer as UserRegisterResponse;
          this.authService.setUserAuth(key, otherInfo);
        }
      })).then(() => {
        this.authService.setUserAuth(selectServer, user);
        this.isLogging = false;
        this.$router.push("/");
      })

    } catch (e) {
       this.isLogging = false;
       switch (e.message) {
         case (ApiErrors.REGISTER_EMAIL_EXIST): {
           this.formErrors.email = this.$t('signup_page.form.inputs.email.invalid_error').toString();
           break;
         }
         default: {
           throw e;
         }
       }
    }
  }
}
